import React from 'react'
import './contact.css'
import {HiOutlineMail} from 'react-icons/hi'
import {BsWhatsapp} from 'react-icons/bs'

import { useRef } from 'react';
import emailjs from 'emailjs-com'
import { personalInfo } from '../../data'


const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_9460vxc', 'template_ua8pi7a', form.current, 'tQm-LnoIAnRE7Yr9s')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

      e.target.reset()
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <HiOutlineMail className='contact__option-icon' />
            <h4>Email</h4>
            <h5>{personalInfo.email}</h5>
            <a href={`mailto:${personalInfo.email}`} target='_blank' rel='noreferrer'>Send a Message</a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className='contact__option-icon' />
            <h4>WhattsApp</h4>
            <h5>Lets Discuss</h5>
            <a href={`https://api.whatsapp.com/send/?phone=${personalInfo.whatsappNumber}`} target='_blank' rel='noreferrer'>Send a Message</a>
          </article>
      </div>
      {/* end of contact options */}

      <form ref={form} onSubmit={sendEmail}>
        <input type="text" name='name' placeholder='Your Full Name' required />
        <input type="email" name='email' placeholder='Your Email' required/>
        <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
        <button type='submit' className='btn btn-primary'>Send</button>
      </form>
      </div>
    </section>
  )
}

export default Contact